// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum ModalMode {
	DOCKED = 'docked',
	DEFAULT = 'default',
	EXPANDED = 'expanded',
}
